var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card-container"},[_c('CardVue',{attrs:{"title":_vm.label1,"text":_vm.Text1}}),_c('CardVue',{attrs:{"title":_vm.label,"text":_vm.Text}}),_c('cardGal')],1),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }